import { useState } from "react";
import Stack from "@mui/joy/Stack";
import Tab from "@mui/joy/Tab";
import Typography from "@mui/joy/Typography";
import TabPanel, { tabPanelClasses } from "@mui/joy/TabPanel";
import TabList from "@mui/joy/TabList";
import { HEADER_HEIGHT, NAVBAR_HEIGHT } from "@/types/constants/common";
import Tabs from "@mui/joy/Tabs";
import { agentAgencyFormTabs } from "../constants/constant";
import CreateAgentForm from "./CreateAgentForm";
import CreateAgencyForm from "./CreateAgencyForm";
import UpdateAgentForm from "./UpdateAgentForm";
import UpdateAgencyForm from "./UpdateAgencyForm";

const AgentAgencyForms = () => {
  const [activeTab, setActiveTab] = useState<string>(agentAgencyFormTabs.createAgency.id);

  return (
    <Stack>
      <Tabs
        aria-label="Manage Agent/Agency"
        orientation="horizontal"
        value={activeTab}
        onChange={(_, value) => {
          setActiveTab(value as string);
        }}
        size="sm"
        sx={{
          width: "100%",
          bgcolor: "white",
          [`& .${tabPanelClasses.root}`]: {
            px: 2,
            py: 4,
            pb: 8,
          },
        }}
      >
        <TabList
          sticky="top"
          sx={{
            top: HEADER_HEIGHT + NAVBAR_HEIGHT + "px",
            zIndex: 20,
          }}
        >
          {Object.values(agentAgencyFormTabs).map((tab) => (
            <Tab
              key={tab.id}
              value={tab.id}
              color={activeTab === tab.id ? "primary" : undefined}
              sx={{
                fontWeight: activeTab === tab.id ? "600" : "md",
                py: 0.8,
                px: 2,
              }}
            >
              <Typography
                fontSize={"sm"}
                color={activeTab === tab.id ? "primary" : undefined}
                startDecorator={<tab.Icon />}
              >
                {tab.title}
              </Typography>
            </Tab>
          ))}
        </TabList>

        <TabPanel value={agentAgencyFormTabs.createAgent.id}>
          <CreateAgentForm />
        </TabPanel>
        <TabPanel value={agentAgencyFormTabs.createAgency.id}>
          <CreateAgencyForm />
        </TabPanel>
        <TabPanel value={agentAgencyFormTabs.updateAgent.id}>
          <UpdateAgentForm />
        </TabPanel>
        <TabPanel value={agentAgencyFormTabs.updateAgency.id}>
          <UpdateAgencyForm />
        </TabPanel>
      </Tabs>
    </Stack>
  );
};

export default AgentAgencyForms;
